export default "__VITE_ASSET__BExoeNip__"